export const GET_LOCAL_POWER_PRODUCTION = 'GET_LOCAL_POWER_PRODUCTION';
export const GET_HOUSEHOLD = 'GET_HOUSEHOLD';
export const SET_LOCAL_POWER_PRODUCTION = 'SET_LOCAL_POWER_PRODUCTION';
export const SET_HOUSEHOLD = 'SET_HOUSEHOLD';
